import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import { BookingHistorySlice } from "../../../../redux/features/BookingHistory";
import { Loader } from "../../../../common/Loader/Loader";
import Pagination from "../../../../common/pagination/PaginationCustom";
import useParamsFormat from "../../../../common/Params Values format/ParamsFormat";
import { toast } from "react-toastify";

const BookingHistory = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [iState, setUpdate] = useState([]);
  const { loading } = useSelector((state) => state.Booking);
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    page: 1,
  });
  const { createDataSetParams } = useParamsFormat();

  useEffect(() => {
    const dataSet = createDataSetParams({ ...getSearch });
    dispatch(BookingHistorySlice({ id, dataSet })).then((res) => {
      setUpdate(res?.payload?.data);
      setPagination(res.payload.pagination);
    });
  }, [id]);

  const handlePagesIncrease = () => {
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);
    setGetSearch((prev) => ({ ...prev, page: pageNum }));
    const dataSet = createDataSetParams({ ...getSearch, page: pageNum });
    dispatch(BookingHistorySlice(id, dataSet)).then((res) => {
      const dummyData = res?.payload?.data;
      setUpdate(dummyData);
      setPagination(res.payload.pagination);
    });
  };

  useEffect(() => {
    if (Object.entries(pagination ?? {}).length > 0) {
      setArr(
        [...Array(pagination?.totalPages + 1).keys()]
          .slice(1)
          .slice(handleArrforPage - 1, handleArrforPage + 2)
      );
    }
  }, [pagination, handleArrforPage]);

  const HandleSearch = () => {
    //search=hello&fromDate=2024-12-05&toDate=2024-12-19&
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      if (
        ![getSearch.fromDate.length, getSearch.toDate.length].every(
          (item) => item === 0
        )
      ) {
        if (
          ![getSearch.fromDate.length, getSearch.toDate.length].every(
            (item) => item > 0
          )
        ) {
          toast.error("Please complete the date!");
          return;
        }
      }

      const dataSet = createDataSetParams({ ...getSearch });

      dispatch(BookingHistorySlice({ id, dataSet })).then((res) => {
        const dummyData = res?.payload?.data;
        setUpdate(dummyData);
        setPagination(res.payload.pagination);
      });
    }
  };

  const HandleReset = () => {
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      setGetSearch({
        search: "",
        fromDate: "",
        toDate: "",
        page: 1,
      });

      const dataSet = createDataSetParams({ ...getSearch });

      dispatch(BookingHistorySlice({ id, dataSet })).then((res) => {
        console.log("newsres", res);
        const dummyData = res?.payload?.data;
        setUpdate(dummyData);
        setPagination(res.payload.meta);
      });
    }
  };

  return (
    <>
      <div className="Small-Wrapper">
        <div className="Filter">
          <div className="form-group">
            <label>Search</label>
            <input
              type="search"
              className="form-control"
              placeholder="Search"
              name="search"
              value={getSearch?.search}
              onChange={(e) =>
                setGetSearch((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }
            />
          </div>
          <div className="form-group">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              name="fromDate"
              value={getSearch?.fromDate}
              onChange={(e) =>
                setGetSearch((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }
            />
          </div>
          <div className="form-group">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              value={getSearch?.toDate}
              name="toDate"
              onChange={(e) =>
                setGetSearch((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }
            />
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <button
              className="Button"
              style={{ marginRight: "10px" }}
              onClick={HandleSearch}
            >
              Apply
            </button>

            <button className="Button Cancel" onClick={HandleReset}>
              <i className="fa fa-refresh" />
            </button>
          </div>
        </div>
      </div>
      <div className="TableList">
        <table style={{ width: "130%" }}>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Booking Id</th>
              <th>Booking Date &amp; Time</th>
              <th>Decorator Address</th>
              <th>Item Quantity</th>
              <th>Amount(in TZS)</th>
              <th>Payment Mode</th>
              <th>Payment Status</th>
              <th>Booking Status</th>
              <th>View Booking Details</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <Loader />
            ) : Array.isArray(iState) && iState.length > 0 ? (
              iState?.map((data, index) => {
                return (
                  <tr>
                    <td>{(pagination?.currentPage - 1) * 10 + index + 1}</td>
                    <td>{data?.bookingId}</td>
                    <td>{data?.createdAt?.slice(0,10)}</td>
                    <td>
                      <p>
                      <div dangerouslySetInnerHTML={{ __html: data?.productDescription?.slice(0,30) }} />
                      </p>
                    </td>
                    <td>{data?.itemQuantity}</td>
                    <td>{data?.productAmount}</td> 
                    <td>{data?.paymentMode}</td>
                    <td>{data?.paymentStatus}</td>
                    <td>
                      <span className="Green">{data?.status}</span>
                    </td>
                    <td>
                      <div className="Actions">
                        <Link
                          className="Blue"
                          state={data}
                          to={`/UsersManagement/UsersListDetails/${id}/UserHistory`}
                        >
                          <i className="fa fa-eye" />
                        </Link>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={10}>there is no user</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination
        arr={arr}
        page={page}
        handlePagesIncrease={handlePagesIncrease}
        FetchDataOnPages={FetchDataOnPages}
        handlePagesDecrease={handlePagesDecrease}
      />
    </>
  );
};

export default BookingHistory;
